function changeDocumentNumber(input, url) {
    var $form = $(input).parents('form');

    if (!$(input).val()) {
        $form.find('[name="order_product_id"]').parents('.form-group').hide();
        $form.find('[name="product_name"]').parents('.form-group').show();

        $form.find('[name="order_product_id"]').parents('.c-form__item').parent().hide();
        $form.find('[name="product_name"]').parents('.c-form__item').parent().show();
    } else {
        Form.fetchDependentOptions(input, 'order_product_id', url, {
            callback: function() {
                $form.find('[name="order_product_id"]').parents('.form-group').show();
                $form.find('[name="product_name"]').parents('.form-group').hide();

                $form.find('[name="order_product_id"]').parents('.c-form__item').parent().show();
                $form.find('[name="product_name"]').parents('.c-form__item').parent().hide();
            }
        });
    }
}

$(function() {
    $('[name="order_product_id"]').bind('change', function() {
        var $this = $(this),
            quantity = $this.find('option:selected').attr('data-quantity'),
            $quantityInput = $('#product-quantity');

        $('[name="product_name"]').val($this.find('option:selected').text());

        $quantityInput.attr('max', quantity);
    });

    $('.js-form-account-claim').validate({
        rules: {
            customer_email: {
                email: true
            },
            customer_post_code: {
                number: true
            }
        },
        errorPlacement: function(error, element) {
            if (element.attr("type") && element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function(form) {
            $(form).find('[type="submit"]')
                .prop('disabled', true)
                .addClass('is-loading');

            window.assignRecaptchaResponseToForm(form).then(function() {
                form.submit();
            });
        }
    });
});
